import { Model } from 'modules/core/lib/mobx-rest'
import { ModelWithPolicy } from 'modules/core/lib/modelWithPolicy'

export interface IResource {
  [key: string]: any
}

class Resource extends Model<IResource> {
  static urlRoot() {
    return '/custom_resources/resources'
  }
}

export default Resource
